// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.popup-content {
    background: white;
    border-radius: 16px;
    padding: 32px;
    width: 90%;
    max-width: 420px;
    position: relative;
    animation: slideUp 0.3s ease-out;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.popup-close {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 28px;
    color: #999;
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;
}

.popup-close:hover {
    color: #333;
}

.popup-header {
    text-align: center;
    margin-bottom: 24px;
}

.popup-header h2 {
    font-size: 1.5rem;
    margin: 0 0 8px 0;
    color: #333;
}

.popup-header p {
    font-size: 0.9rem;
    color: #666;
    margin: 0;
}

.popup-error {
    background-color: #fee;
    color: #c33;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.9rem;
}

.popup-body {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.btn-google {
    width: 100%;
    padding: 14px;
    background: white;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #333;
}

.btn-google:hover:not(:disabled) {
    border-color: #4285f4;
    background: #f8f9ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(66, 133, 244, 0.2);
}

.btn-google:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-google i.fab {
    color: #4285f4;
    font-size: 1.2rem;
}

.popup-divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 8px 0;
}

.popup-divider::before,
.popup-divider::after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid #e0e0e0;
}

.popup-divider span {
    padding: 0 16px;
    color: #999;
    font-size: 0.9rem;
}

.btn-email {
    width: 100%;
    padding: 14px;
    background: white;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #333;
}

.btn-email:hover {
    border-color: #667eea;
    background: #f8f9ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.btn-email i {
    color: #667eea;
}

.form-group {
    margin-bottom: 12px;
}

.form-group input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    font-size: 1rem;
    transition: all 0.3s ease;
    box-sizing: border-box;
}

.form-group input:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.btn-submit {
    width: 100%;
    padding: 14px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 8px;
}

.btn-submit:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
}

.btn-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.popup-toggle {
    text-align: center;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;
}

.popup-toggle p {
    color: #666;
    font-size: 0.9rem;
    margin: 0;
}

.popup-toggle button {
    background: none;
    border: none;
    color: #667eea;
    font-weight: 600;
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
}

.popup-toggle button:hover {
    color: #764ba2;
}

.btn-back {
    width: 100%;
    padding: 12px;
    background: none;
    border: none;
    color: #667eea;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    margin-top: 8px;
}

.btn-back:hover {
    color: #764ba2;
}`, "",{"version":3,"sources":["webpack://./src/components/LoginPopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,0CAA0C;AAC9C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,WAAW;IACX,SAAO;IACP,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".popup-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.7);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 10000;\r\n    animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.popup-content {\r\n    background: white;\r\n    border-radius: 16px;\r\n    padding: 32px;\r\n    width: 90%;\r\n    max-width: 420px;\r\n    position: relative;\r\n    animation: slideUp 0.3s ease-out;\r\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n@keyframes slideUp {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(30px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.popup-close {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 16px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 28px;\r\n    color: #999;\r\n    cursor: pointer;\r\n    width: 32px;\r\n    height: 32px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: color 0.2s;\r\n}\r\n\r\n.popup-close:hover {\r\n    color: #333;\r\n}\r\n\r\n.popup-header {\r\n    text-align: center;\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.popup-header h2 {\r\n    font-size: 1.5rem;\r\n    margin: 0 0 8px 0;\r\n    color: #333;\r\n}\r\n\r\n.popup-header p {\r\n    font-size: 0.9rem;\r\n    color: #666;\r\n    margin: 0;\r\n}\r\n\r\n.popup-error {\r\n    background-color: #fee;\r\n    color: #c33;\r\n    padding: 12px 16px;\r\n    border-radius: 8px;\r\n    margin-bottom: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.popup-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n}\r\n\r\n.btn-google {\r\n    width: 100%;\r\n    padding: 14px;\r\n    background: white;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 10px;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    color: #333;\r\n}\r\n\r\n.btn-google:hover:not(:disabled) {\r\n    border-color: #4285f4;\r\n    background: #f8f9ff;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(66, 133, 244, 0.2);\r\n}\r\n\r\n.btn-google:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.btn-google i.fab {\r\n    color: #4285f4;\r\n    font-size: 1.2rem;\r\n}\r\n\r\n.popup-divider {\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    margin: 8px 0;\r\n}\r\n\r\n.popup-divider::before,\r\n.popup-divider::after {\r\n    content: '';\r\n    flex: 1;\r\n    border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.popup-divider span {\r\n    padding: 0 16px;\r\n    color: #999;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.btn-email {\r\n    width: 100%;\r\n    padding: 14px;\r\n    background: white;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 10px;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    color: #333;\r\n}\r\n\r\n.btn-email:hover {\r\n    border-color: #667eea;\r\n    background: #f8f9ff;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\r\n}\r\n\r\n.btn-email i {\r\n    color: #667eea;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.form-group input {\r\n    width: 100%;\r\n    padding: 12px 16px;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 10px;\r\n    font-size: 1rem;\r\n    transition: all 0.3s ease;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.form-group input:focus {\r\n    outline: none;\r\n    border-color: #667eea;\r\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\r\n}\r\n\r\n.btn-submit {\r\n    width: 100%;\r\n    padding: 14px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 10px;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    margin-top: 8px;\r\n}\r\n\r\n.btn-submit:hover:not(:disabled) {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);\r\n}\r\n\r\n.btn-submit:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.popup-toggle {\r\n    text-align: center;\r\n    margin-top: 16px;\r\n    padding-top: 16px;\r\n    border-top: 1px solid #e0e0e0;\r\n}\r\n\r\n.popup-toggle p {\r\n    color: #666;\r\n    font-size: 0.9rem;\r\n    margin: 0;\r\n}\r\n\r\n.popup-toggle button {\r\n    background: none;\r\n    border: none;\r\n    color: #667eea;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    text-decoration: underline;\r\n    padding: 0;\r\n}\r\n\r\n.popup-toggle button:hover {\r\n    color: #764ba2;\r\n}\r\n\r\n.btn-back {\r\n    width: 100%;\r\n    padding: 12px;\r\n    background: none;\r\n    border: none;\r\n    color: #667eea;\r\n    font-size: 0.9rem;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    margin-top: 8px;\r\n}\r\n\r\n.btn-back:hover {\r\n    color: #764ba2;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
